import { pageHead } from "@/lib/route-head";
import { getAudiencePage } from "@/data/audience-pages";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AudienceLanding = lazy(() => import("@/pages/AudienceLanding"));

export const Route = createFileRoute("/parents-dinners")({
  head: () => { const p = getAudiencePage("parents-dinners"); return pageHead({ path: "/parents-dinners", title: p?.title ?? "Amorette", description: p?.description ?? "" }); },
  component: AudienceLanding,
});
